import React, { useState, useEffect } from 'react';
import { get } from '../../../utils/axios';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

function Banner() {

    const [bannerData, setBannerData] = useState([]);

    const getBannerData = () => {
        get(`/banner`)
            .then((res) => {
                if (res.success) {
                    setBannerData(res.data);
                }
            })
    };

    useEffect(() => {
        getBannerData();
    }, [])


    const arrowStyles = {
        position: 'absolute',
        zIndex: 2,
        top: 'calc(50% - 15px)',
        width: 40,
        height: 40,
        cursor: 'pointer',
        border: 'none',
        borderRadius: '50%',
        background: '#0E3B80',
        color: 'white',
        fontSize: '25px'
    };


    return (
        <section id="herobanner" className="heroBannerwrapper">
            <div className="container">

                <Carousel autoPlay={true} infiniteLoop={true}
                    showStatus={false} showIndicators={true}
                    showThumbs={false} swipeable={true}
                    emulateTouch={true} autoFocus={true} showArrows={true}

                    renderArrowPrev={(onClickHandler, hasPrev, label) =>
                        hasPrev && (
                            <button type="button" onClick={onClickHandler} title={label} style={{ ...arrowStyles, left: 15 }}>
                                {'<'}
                            </button>
                        )
                    }
                    renderArrowNext={(onClickHandler, hasNext, label) =>
                        hasNext && (
                            <button type="button" onClick={onClickHandler} title={label} style={{ ...arrowStyles, right: 15 }}>
                                {'>'}
                            </button>
                        )
                    }

                >
                    {
                        bannerData && bannerData.length > 0 && bannerData.map((item, index) => {
                            return (

                                <div className="item" key={item._id}>
                                    <div className="heroBanner">
                                        <div className="bannerContent">
                                            {(item.heading && item.heading.trim().length > 0) && <h1 style={{ textAlign: 'left' }}>
                                                {item.heading}
                                            </h1>}

                                            {(item.description && item.description.trim().length > 0) && <h2 style={{ textAlign: 'left' }}>
                                                {item.description}
                                            </h2>}
                                            {(item.buttonText && item.buttonText.trim().length > 0) && <div className="mainCtablock">
                                                <a href={item.clickLink} className="maincta" target='_blank' rel='noreferrer'>
                                                    <span>{item.buttonText}</span>
                                                    <img src="images/arrow.svg" alt="" style={{ width: 'auto', display: 'inline-block', verticalAlign: 'inherit' }} />
                                                </a>
                                            </div>}
                                        </div>
                                        <div className="bannerImage"><img src={item.image} alt="" /></div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </Carousel>
            </div>
        </section>
    )
}

export default Banner;